// Master toggle for the whole payments system. The product is currently free
// for all users, so this is false and every payment/paywall UI element and
// entitlement check short-circuits around it. Flip back to true to restore
// paid plans/listing quotas.
export const PAYMENTS_ENABLED = false
